export default __webpack_public_path__ + "static/media/Kova-Light.45082daf.png";